export default __webpack_public_path__ + "static/media/TwoInThePunkOneInTheSkunk.279d7bf8.mp3";